// Authorization data
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    accessToken: '',
    refreshToken: '',
    accessTokenExpDate: null,
    refreshTokenExpDate: null,
    loginByHand: false,  // признак того что человек прилогинился сам, а не автоматом по ранее сохраненным токенам
    // paswordResetToken: '',
    // emailConfirmationToken: '',
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.accessTokenExpDate = action.payload.accessTokenExpDate;
            state.refreshTokenExpDate = action.payload.refreshTokenExpDate;
            state.loginByHand = action.payload.loginByHand;
        },
        // setPasswordResetToken: (state, action) => {
        //     state.paswordResetToken = action.payload;
        // },
        // setEmailConfirmationToken: (state, action) => {
        //     state.emailConfirmationToken = action.payload;
        // },
    },
});

export const {
    setAuth,
    // setPasswordResetToken, setEmailConfirmationToken 
} = authSlice.actions;

export const isAuthenticated = (state) => (state.auth.accessToken != null && state.auth.accessToken != '');
export const getAuth = (state) => state.auth;
// export const getPasswordResetToken = (state) => state.auth.paswordResetToken;
// export const getEmailConfirmationToken = (state) => state.auth.emailConfirmationToken;

export default authSlice.reducer;